import React, { useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { Route } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import SidebarNavList from "./sidebar-nav-list.jsx";
import menus_import from "./menu.jsx";
import _ from "lodash";

const SidebarNav = () => {
    const context = useContext(AppSettings);

    const [active, setActive] = useState(-1);
    const [clicked, setClicked] = useState(-1);
    const [menus, setMenus] = useState([]);

    const session = useSelector((state) => state.session.user);

    useEffect(() => {
        if (session?.admin) {
            setMenus(menus_import);
        } else {
            setMenus(_.reject(menus_import, "needAdmin"));
        }
    }, [session]);

    const handleExpand = (e, i, match) => {
        e.preventDefault();
        if (clicked === -1 && match) {
            setActive(-1);
            setClicked(1);
        } else {
            setActive(active === i ? -1 : i);
            setClicked(1);
        }
    };

    const handleSidebarSearch = (e) => {
        let searchValue = e.target.value;
        searchValue = searchValue.toLowerCase();

        this.setState((state) => {
            let newMenus = [];
            if (searchValue !== "") {
                newMenus = menus.filter((item) => {
                    let title = item.title;
                    title = title.toLowerCase();
                    if (title.search(searchValue) > -1) {
                        item.search = true;
                        return true;
                    } else {
                        if (item.children) {
                            for (var i = 0; i < item.children.length; i++) {
                                let title2 = item.children[i]["title"];
                                title2 = title2.toLowerCase();

                                if (title2.search(searchValue) > -1) {
                                    item.search = true;
                                    return true;
                                }
                            }
                        }
                        return false;
                    }
                });
            } else {
                newMenus = menus.filter((item) => {
                    item.search = false;
                    return true;
                });
            }
            return {
                menus: newMenus,
            };
        });
    };

    return (
        <div className="menu">
            {context.appSidebarSearch && (
                <div className="menu-search mb-n3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Sidebar menu filter..."
                        onKeyUp={handleSidebarSearch}
                    />
                </div>
            )}
            <div className="menu-header">Navigation</div>
            {menus.map((menu, i) => (
                <Route
                    path={menu.path}
                    exact={menu.exact}
                    key={i}
                    children={({ match }) => (
                        <SidebarNavList
                            data={menu}
                            key={i}
                            expand={(e) => handleExpand(e, i, match)}
                            active={i === active}
                            clicked={clicked}
                        />
                    )}
                />
            ))}
        </div>
    );
};

export default SidebarNav;
